import ActionTypes from '../constants/ActionTypes';
import Events from '../constants/Events';

export const FETCHING_USERS = 'FETCHING_USERS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAIL = 'FETCH_USERS_FAIL';
export const FETCHING_USER_CLIENTS = 'FETCHING_USER_CLIENTS';
export const FETCH_USER_CLIENTS_SUCCESS = 'FETCH_USER_CLIENTS_SUCCESS';
export const FETCH_USER_CLIENTS_FAILED = 'FETCH_USER_CLIENTS_FAILED';
export const FETCHING_INVITATION = 'FETCHING_INVITATION';
export const FETCH_INVITATION_SUCCESS = 'FETCH_INVITATION_SUCCESS';
export const FETCH_INVITATION_FAILED = 'FETCH_INVITATION_FAILED';
export const FETCHING_INVITATIONS = 'FETCHING_INVITATIONS';
export const FETCH_INVITATIONS_SUCCESS = 'FETCH_INVITATIONS_SUCCESS';
export const FETCH_INVITATIONS_FAILED = 'FETCH_INVITATIONS_FAILED';
export const REINVITING_USER = 'REINVITING_USER';
export const REINVITE_USER_SUCCESS = 'REINVITE_USER_SUCCESS';
export const REINVITE_USER_FAILED = 'REINVITE_USER_FAILED';
export const APPROVING_INVITATION = 'APPROVING_INVITATION';
export const APPROVING_INVITATION_SUCCESS = 'APPROVING_INVITATION_SUCCESS';
export const APPROVING_INVITATION_FAILED = 'APPROVING_INVITATION_FAILED';
export const BULK_APPROVING_INVITATIONS = 'BULK_APPROVING_INVITATIONS';
export const BULK_APPROVE_INVITATIONS_SUCCESS = 'BULK_APPROVE_INVITATIONS_SUCCESS';
export const BULK_APPROVE_INVITATIONS_FAILED = 'BULK_APPROVE_INVITATIONS_FAILED';
export const BULK_REINVITING_USERS = 'BULK_REINVITING';
export const BULK_REINVITING_USERS_SUCCESS = 'BULK_REINVITING_USERS_SUCCESS';
export const BULK_REINVITING_USERS_FAILED = 'BULK_REINVITING_USERS_FAILED';
export const REFRESHING_TOKEN = 'REFRESHING_TOKEN';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAILED = 'REFRESH_TOKEN_FAILED';
export const REFRESH_USER_DETAILS = 'REFRESH_USER_DETAILS';
export const USER_DETAILS_REFRESHED = 'USER_DETAILS_REFRESHED';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SETTING_FEDERATION_ID = 'UPDATING_FEDERATION_ID';
export const SET_FEDERATION_ID_SUCCESS = 'SET_FEDERATION_ID_SUCCESS';
export const SET_FEDERATION_ID_FAILED = 'SET_FEDERATION_ID_FAILED';
export const LINKING_INVITATION = 'LINKING_INVITATION';
export const LINK_INVITATION_SUCCESS = 'LINK_INVITATION_SUCCESS';
export const LINK_INVITATION_FAILURE = 'LINK_INVITATION_FAILURE';
export const CREATING_INVITATIONS = 'CREATING_INVITATIONS';
export const CREATING_INVITATIONS_SUCCESS = 'CREATING_INVITATIONS_SUCCESS';
export const CREATING_INVITATIONS_FAILED = 'CREATING_INVIATIONS_FAILED';
export const REMOVING_USER = 'REMOVING_USER';
export const REMOVING_USER_SUCCESS = 'REMOVING_USER_SUCCESS';
export const REMOVING_USER_FAILED = 'REMOVING_USER_FAILED';
export const REMOVING_USER_RESET = 'REMOVING_USER_RESET';
export const CLEARING_STORE = 'CLEARING_STORE';
export const SETTING_INACTIVE_DATE = 'UPDATING_INACTIVE_DATE';
export const SET_INACTIVE_DATE_SUCCESS = 'SET_INACTIVE_DATE_SUCCESS';
export const SET_INACTIVE_DATE_FAILURE = 'SET_INACTIVE_DATE_FAILURE';
export const UPDATING_INVITATION = 'UPDATING_INVITATION';
export const UPDATE_INVITATION_SUCCESS = 'UPDATE_INVITATION_SUCCESS';
export const UPDATE_INVITATION_FAILURE = 'UPDATE_INVITATION_FAILURE';

export const fetchingUsers = () => {
    return {
        type: FETCHING_USERS
    };
};

export const fetchUsersSuccess = users => {
    return {
        type: FETCH_USERS_SUCCESS,
        payload: users
    };
};

export const fetchUsersFailed = err => {
    return {
        type: FETCH_USERS_FAIL,
        payload: err
    };
};

export const fetchingInvitation = () => {
    return {
        type: FETCHING_INVITATION
    };
};

export const fetchInvitationSuccess = invitation => {
    return {
        type: FETCH_INVITATION_SUCCESS,
        payload: invitation
    };
};

export const fetchInvitationFailed = err => {
    return {
        type: FETCH_INVITATION_FAILED,
        payload: err
    };
};

export const fetchingInvitations = () => {
    return {
        type: FETCHING_INVITATIONS
    };
};

export const fetchInvitationsSuccess = invitations => {
    return {
        type: FETCH_INVITATIONS_SUCCESS,
        payload: invitations
    };
};

export const fetchInvitationsFailed = err => {
    return {
        type: FETCH_INVITATIONS_FAILED,
        payload: err
    };
};

export const reinvitingUser = () => {
    return {
        type: REINVITING_USER
    };
};

export const reinviteUserSuccess = payload => {
    return {
        type: REINVITE_USER_SUCCESS,
        payload
    };
};

export const reinviteUserFailed = err => {
    return {
        type: REINVITE_USER_FAILED,
        payload: err
    };
};

export const approvingInvitation = () => {
    return {
        type: APPROVING_INVITATION
    };
};

export const approvingInvitationSuccess = payload => {
    return {
        type: APPROVING_INVITATION_SUCCESS,
        payload
    };
};

export const approvingInvitationFailed = err => {
    return {
        type: APPROVING_INVITATION_FAILED,
        payload: err
    };
};

export const bulkApprovingInvitations = () => {
    return {
        type: BULK_APPROVING_INVITATIONS
    };
};

export const bulkApproveInvitationsSuccess = payload => {
    return {
        type: BULK_APPROVE_INVITATIONS_SUCCESS,
        payload
    };
};

export const bulkApproveInvitationsFailed = err => {
    return {
        type: BULK_APPROVE_INVITATIONS_FAILED,
        payload: err
    };
};

export const bulkReinvitingUsers = () => {
    return {
        type: BULK_REINVITING_USERS
    };
};

export const bulkReinvitingUsersSuccess = payload => {
    return {
        type: BULK_REINVITING_USERS_SUCCESS,
        payload
    };
};

export const bulkReinvitingUsersFailed = error => {
    return {
        type: BULK_REINVITING_USERS_FAILED,
        payload: error
    };
};

export const loginSuccess = () => {
    return {
        type: Events.LOGIN_SUCCESS
    };
};

export const loginFailed = error => {
    return {
        type: Events.LOGIN_FAILED,
        payload: error
    };
};

export const refreshUserDetails = () => ({
    type: REFRESH_USER_DETAILS
});

export const userDetailsRefreshed = () => ({
    type: USER_DETAILS_REFRESHED
});

export const setUserInfo = payload => {
    return {
        type: SET_USER_INFO,
        user: payload
    };
};

export const loggingIn = () => {
    return {
        type: ActionTypes.LOGIN
    };
};

export const loggingOut = () => {
    return {
        type: ActionTypes.LOGOUT
    };
};

export const logoutSuccess = () => {
    return {
        type: Events.LOGOUT_SUCCESS
    };
};

export const logoutFailed = error => {
    return {
        type: Events.LOGOUT_FAILED,
        payload: error
    };
};

export const resettingPassword = () => {
    return {
        type: ActionTypes.RESET_PASSWORD
    };
};

export const resetPasswordSuccess = () => {
    return {
        type: Events.RESET_PASSWORD_SUCCESS
    };
};

export const resetPasswordFailed = error => {
    return {
        type: Events.RESET_PASSWORD_FAILED,
        payload: error
    };
};

export const changingPassword = () => {
    return {
        type: ActionTypes.CHANGE_PASSWORD,
        passwordIsChanging: true
    };
};

export const changePasswordSuccess = () => {
    return {
        type: Events.CHANGE_PASSWORD_SUCCESS,
        passwordIsChanging: false
    };
};

export const changePasswordFailed = error => {
    return {
        type: Events.CHANGE_PASSWORD_FAILED,
        passwordIsChanging: false,
        payload: error
    };
};

export const refreshingToken = () => {
    return {
        type: REFRESHING_TOKEN
    };
};

export const refreshTokenSuccess = () => {
    return {
        type: REFRESH_TOKEN_SUCCESS
    };
};

export const refreshTokenFailed = err => {
    return {
        type: REFRESH_TOKEN_FAILED,
        payload: err
    };
};

export const fetchingUserClients = () => {
    return { type: FETCHING_USER_CLIENTS };
};

export const fetchUserClientsSuccess = clients => {
    return { type: FETCH_USER_CLIENTS_SUCCESS, payload: clients };
};

export const fetchUserClientsFailed = err => {
    return { type: FETCH_USER_CLIENTS_FAILED, payload: err };
};

export const resetIsPasswordChanged = () => ({
    type: Events.RESET_IS_PASSWORD_CHANGED
});

export const settingFederationId = () => ({
    type: SETTING_FEDERATION_ID,
});

export const setFederationIdSuccess = () => ({
    type: SET_FEDERATION_ID_SUCCESS,
});

export const setFederationIdFailure = error => ({
    type: SET_FEDERATION_ID_FAILED,
    error,
});

export const creatingInvitations = () => {
    return {
        type: CREATING_INVITATIONS
    };
};

export const creatingInvitationsSuccess = response => {
    return {
        type: CREATING_INVITATIONS_SUCCESS,
        payload: response
    };
};

export const creatingInvitationsFailed = err => {
    return {
        type: CREATING_INVITATIONS_FAILED,
        payload: err
    };
};

export const clearingStore = () => {
    return {
        type: CLEARING_STORE
    }
};

export const linkingInvitations = () => ({
    type: LINKING_INVITATION
});

export const linkInvitationSuccess = () => ({
    type: LINK_INVITATION_SUCCESS
});

export const linkInvitationFailure = error => ({
    type: LINK_INVITATION_FAILURE,
    payload: error
});

export const removingUser = () => ({
    type: REMOVING_USER
});

export const removingUserFailed = error => ({
    type: REMOVING_USER_FAILED,
    payload: error
});

export const removingUserSuccess = data => ({
    type: REMOVING_USER_SUCCESS,
    payload: data
});

export const removingUserReset = () => ({
    type: REMOVING_USER_RESET
});

export const settingInactiveDate = () => ({
    type: SETTING_INACTIVE_DATE
});

export const setInactiveDateSuccess = response => ({
    type: SET_INACTIVE_DATE_SUCCESS,
    payload: response
});

export const setInactiveDateFailure = error => ({
    type: SET_INACTIVE_DATE_FAILURE,
    payload: error
});

export const updatingInvitation = () => ({
    type: UPDATING_INVITATION
});

export const updateInvitationSuccess = response => ({
    type: UPDATE_INVITATION_SUCCESS,
    payload: response
});

export const updateInvitationFailure = error => ({
    type: UPDATE_INVITATION_FAILURE,
    payload: error
});